import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import App from "App";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";

// Auth context
import { AuthProvider } from "auth/AuthContext";

// Content-type registry context (slug → id map)
import { ContentTypesProvider } from "context/ContentTypesContext";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <BrowserRouter basename={process.env.PUBLIC_URL}>
    <AuthProvider>
      <ContentTypesProvider>
        <MaterialUIControllerProvider>
          <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
            <App />
          </SnackbarProvider>
        </MaterialUIControllerProvider>
      </ContentTypesProvider>
    </AuthProvider>
  </BrowserRouter>
);
